<template>
  <Notebook/>
</template>

<script>
import Notebook from './components/Notebook';

export default {
  name: 'App',
  components: {
    Notebook,
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue